/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 24, height = 24 }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 1.5863V5.5863M16 1.5863V5.5863M21 12.5863V5.5863C21 5.05587 20.7893 4.54716 20.4142 4.17209C20.0391 3.79702 19.5304 3.5863 19 3.5863H5C4.46957 3.5863 3.96086 3.79702 3.58579 4.17209C3.21071 4.54716 3 5.05587 3 5.5863V19.5863C3 20.1167 3.21071 20.6254 3.58579 21.0005C3.96086 21.3756 4.46957 21.5863 5 21.5863H13M3 9.5863H21M16 18.5863H22M19 15.5863V21.5863"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgComponent;
